var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vSelect',{attrs:{"options":_vm.scheduleTypeOptions,"disabled":_vm.disabled,"reduce":option => option.id,"label":"name"},model:{value:(_vm.scheduleTypeId),callback:function ($$v) {_vm.scheduleTypeId=$$v},expression:"scheduleTypeId"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }